import { useState, useEffect } from 'react';
import { FaSync, FaEllipsisV } from 'react-icons/fa';
import { Menu, MenuItem } from '@mui/material';
import axios from '../../services/api';
import { toast } from 'react-toastify';
// import CreateCommunityModal from './modals/CreateCommunityModal';
import ConfirmModal from '../../components/modals/ConfirmModal';
// import DetailCommunityModal from './modals/DetailCommunityModal';
// import BuildingModal from './modals/BuildingModal';
// import ContractModal from './modals/ContractModal';
// import PublicServiceModal from './modals/PublicServiceModal';
// import EntranceModal from './modals/EntranceModal';
// import StartCommunityServiceModal from './modals/StartCommunityServiceModal';
import CallCenterModal from './modals/CallCenterModal';
import editIcon from '../../styles/edit_icon.png';
import { useTranslation } from 'react-i18next';
import QRCodeModal from '../../components/modals/QRCodeModal';

export default function CallCenter() {
  const { t } = useTranslation();
  const [callCenters, setCallCenters] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isQRCodeModalOpen, setIsQRCodeModalOpen] = useState(false);
  const [selectedCallCenter, setSelectedCallCenter] = useState(null);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);

  useEffect(() => {
    fetchCallCenters();
  }, []);

  const fetchCallCenters = async () => {
    try {
      const response = await axios.get('/callcenters');
      setCallCenters(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      await fetchCallCenters();
    } catch (error) {
      console.error(error);
    } finally {
      setIsRefreshing(false);
    }
  };

  const filteredCallCenters = callCenters.filter(callCenter => {
    const matchesSearch =
      callCenter.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      callCenter.domain.toLowerCase().includes(searchTerm.toLowerCase());

    return matchesSearch;
  });

  const handleDelete = async () => {
    try {
      await axios.delete(`/callcenters/${selectedCallCenter._id}`);
      toast.success(t('Call center deleted successfully'));
      fetchCallCenters();
      setIsConfirmOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  const handleMenuClick = (event, callCenter) => {
    setAnchorEl(event.currentTarget);
    setSelectedCallCenter(callCenter);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="p-6 bg-gradient-to-br from-skin-base to-skin-secondary container-height app-text">
      <div className="flex justify-between items-center bg-skin-primary p-4 gap-4 mb-6 rounded-xl shadow-lg h-filter">
        <div className="flex-1 flex items-center gap-4">
          <input
            type="text"
            placeholder={t('Search call centers...')}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />

          <button
            onClick={handleRefresh}
            className="p-2 text-gray-600 hover:text-gray-800"
            disabled={isRefreshing}
          >
            <FaSync className={isRefreshing ? 'animate-spin' : ''} />
          </button>
        </div>

        <button
          onClick={() => {
            setIsModalOpen(true);
            setSelectedCallCenter(null);
          }}
          className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
        >
          {t('+ Create New')}
        </button>
      </div>

      {/* Table */}
      <div
        className={`${filteredCallCenters.length > 0 ? 'overflow-x-auto' : 'overflow-hidden'} h-table-height-counter`}
      >
        <table className="w-full">
          <thead className="sticky top-0 z-30 bg-skin-primary shadow-sm">
            <tr className="border-b border-skin-base/10">
              <th className="sticky left-0 z-10 bg-white bg-skin-primary px-6 py-3 text-center text-sm font-semibold text-skin-base min-w-[50px]">
                {t('No')}
              </th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-skin-base min-w-[150px]">
                {t('Call Center Name')}
              </th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-skin-base min-w-[180px]">
                {t('Category')}
              </th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-skin-base min-w-[120px]">
                {t('Agent')}
              </th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-skin-base min-w-[120px]">
                {t('URL')}
              </th>
              <th className="sticky right-0 z-10 bg-white px-6 py-3 text-left text-sm font-semibold text-skin-base min-w-[100px]">
                {t('Actions')}
              </th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {filteredCallCenters.map((callCenter, index) => {
              return (
                <tr key={callCenter._id} className="border-t border-skin-base/10">
                  <td className="sticky left-0 z-10 bg-skin-primary px-6 py-4 text-sm text-skin-base text-center">
                    {index + 1}
                  </td>
                  <td className="px-6 py-4 text-sm text-skin-base whitespace-nowrap">
                    {callCenter.name}
                  </td>
                  <td className="px-6 py-4 text-sm text-skin-base whitespace-nowrap">
                    {callCenter?.categories?.length || '0'}
                  </td>
                  <td className="px-6 py-4 text-sm text-skin-base whitespace-nowrap">
                    {callCenter?.agents?.length || '0'}
                  </td>
                  <td className="px-6 py-4 text-sm text-skin-base whitespace-nowrap">
                    {`${callCenter.domain}/${callCenter.url}`}
                  </td>
                  <td className="sticky bg-skin-primary right-0 z-10 px-6 py-4 text-sm text-skin-base whitespace-nowrap">
                    <div className="flex items-center gap-2">
                      <button
                        onClick={() => {
                          setSelectedCallCenter(callCenter);
                          setIsModalOpen(true);
                        }}
                        className="text-gray-600 hover:text-gray-900"
                      >
                        <img src={editIcon} alt="edit" className="w-4 h-4" />
                      </button>
                      <button
                        onClick={e => handleMenuClick(e, callCenter)}
                        className="text-gray-600 hover:text-gray-900"
                      >
                        <FaEllipsisV />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <CallCenterModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setSelectedCallCenter(null);
        }}
        onSuccess={() => {
          fetchCallCenters();
        }}
        callCenter={selectedCallCenter}
      />

      <ConfirmModal
        isOpen={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        onConfirm={handleDelete}
        title={t('Delete Call Center')}
        message={
          selectedCallCenter?.categories?.length > 0
            ? t(
                'This call center has categories assigned to it. Are you sure you want to delete it? All categories will be deleted from this call center.'
              )
            : t('Are you sure you want to delete this call center? This action cannot be undone.')
        }
        confirmText={t('Delete')}
        cancelText={t('Cancel')}
        type="danger"
      />

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className="mt-2"
        PaperProps={{
          className: 'bg-[#1c1f3b] border-2 border-[#393e591f] rounded-lg shadow-xl app-text',
          elevation: 0,
        }}
      >
        <MenuItem
          onClick={() => {
            window.open(`${selectedCallCenter?.domain}/${selectedCallCenter?.url}`, '_blank');
            handleClose();
          }}
          className="text-sm px-4 py-2 hover:bg-blue-50"
        >
          {t('Preview')}
        </MenuItem>

        <MenuItem
          onClick={() => {
            setIsQRCodeModalOpen(true);
            handleClose();
          }}
          className="text-sm px-4 py-2 hover:bg-blue-50"
        >
          {t('QRCode')}
        </MenuItem>

        <MenuItem
          onClick={() => {
            setIsConfirmOpen(true);
            handleClose();
          }}
          className="text-white hover:bg-[#292f4c]"
        >
          {t('Delete')}
        </MenuItem>
      </Menu>

      <QRCodeModal
        isOpen={isQRCodeModalOpen}
        onClose={() => setIsQRCodeModalOpen(false)}
        qrValue={`${selectedCallCenter?.domain}/${selectedCallCenter?.url}`}
        title={t('Call Center QR Code')}
      />
    </div>
  );
}
